<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div class="d-flex mh-100 h-100 gap-16 w-100">
  <div class="d-flex flex-column gap-8 w-25 mh-100 h-100">
    <div class="table-title">
      <span>Global Scenarios</span>
    </div>
    <ag-grid-angular
      style="height: 100%; width:100%;"
      class="ag-theme-quartz"
      [rowData]="globalScenarios"
      [columnDefs]="globalColumnDef"
      [autoSizeStrategy]="autoSizeStrategy"
      [rowSelection]="rowSelection"
      (rowSelected)="onSelectGlobal($event)"
    />
  </div>
  <mat-divider vertical></mat-divider>
  <div class="d-flex flex-column gap-8 w-75 mh-100">
    <div class="table-title">
      <span>Selected Member Scenarios</span>
    </div>

    <ag-grid-angular
      style="height: 100%; width:100%;"
      class="ag-theme-quartz"
      [rowData]="memberScenarios"
      [columnDefs]="displayedMemberColumns"
      [autoSizeStrategy]="autoSizeStrategy"
    />
  </div>
</div>
